
export const intervals = [
    { key: "5", text: '5m' },
    { key: "15", text: '15m' },
    { key: "30", text: '30m' },
    { key: "60", text: '1h' },
    { key: "240", text: '4h' }
];